import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron_expand",
  "use": "chevron_expand-usage",
  "viewBox": "0 0 8 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 6\" id=\"chevron_expand\"><path d=\"M.632 1.577 4 3.264l3.368-1.687A.593.593 0 0 0 7.632.79a.59.59 0 0 0-.785-.264L4 1.957 1.146.535A.586.586 0 0 0 .36.8a.58.58 0 0 0 .272.778m6.222 1.29L4 4.292 1.146 2.868a.586.586 0 0 0-.786.264.58.58 0 0 0 .264.786L4 5.598 7.368 3.91a.593.593 0 0 0 .264-.786.57.57 0 0 0-.778-.256\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol